const DashboardHome = () => {
    return (
        <div className="flex items-center justify-center h-full">
            <img
                src="/logo_lockup_on_light.svg"
                alt="StockEasy"
                style={{ width: '840px', maxWidth: '90%' }}
            />
        </div>
    );
};

export default DashboardHome;